<template>
  <div class="center">
    <div class="square_titulo_vacio">
      <div class="square_titulo_valores_vacio" id="Div9" runat="server"></div>
    </div>

    <div class="q-pa-md row items-start">
      <q-card class="my-card-reg-externo">
        <q-card-section class="card_titulo">
          <div class="card_titulo_text">Registrarse</div>
        </q-card-section>
        <q-card-actions>
          <div class="flex-item_30">
            <q-icon name="info" />* Dato Obligatorio
          </div>
          <div class="flex-item_60"></div>
          <div class="flex-item_30">
            <q-field borderless ref="nombre">
              <q-input
                v-model="UsuarioExternoModel.nombre"
                maxlength="30"
                dense
                input-debounce="0"
                :error="$v.UsuarioExternoModel.nombre.$error"
                :rules="[(val) => !!val || 'Dato Obligatorio']"
                type="N"
                label="*Nombre"
                class="col-12"
              >
                <template v-slot:error>Dato obligatorio.</template>
              </q-input>
            </q-field>
          </div>
          <div class="flex-item_50">
            <q-field borderless ref="apellidos">
              <q-input
                v-model="UsuarioExternoModel.apellidos"
                maxlength="50"
                dense
                input-debounce="0"
                :error="$v.UsuarioExternoModel.apellidos.$error"
                :rules="[(val) => !!val || 'Dato Obligatorio']"
                type="N"
                label="*Apellidos"
                class="col-12"
              >
                <template v-slot:error>Dato obligatorio.</template>
              </q-input>
            </q-field>
          </div>
          <div class="flex-item_20">
            <q-field borderless ref="telefono">
              <q-input
                v-model="UsuarioExternoModel.telefono"
                maxlength="15"
                dense
                input-debounce="0"
                :error="$v.UsuarioExternoModel.telefono.$error"
                :rules="[
                  (val) => !!val || 'Dato Obligatorio',
                  (val) => validateTfno(val) || 'Teléfono no válido',
                ]"
                type="N"
                label="*Teléfono"
                class="col-12"
              >
                <template v-slot:error>Dato obligatorio.</template>
              </q-input>
            </q-field>
          </div>

          <div class="flex-item_40">
            <q-field borderless ref="field">
              <q-input
                v-model="UsuarioExternoModel.empresa"
                required
                maxlength="50"
                dense
                input-debounce="0"
                :error="$v.UsuarioExternoModel.empresa.$error"
                :rules="[(val) => !!val || 'Dato Obligatorio']"
                type="N"
                label="*Empresa"
                class="col-12"
              >
                <template v-slot:error>Dato obligatorio.</template>
              </q-input>
            </q-field>
          </div>

          <div class="flex-item_40">
            <q-field borderless ref="email">
              <q-input
                v-model="UsuarioExternoModel.email"
                required
                maxlength="50"
                dense
                input-debounce="0"
                :error="$v.UsuarioExternoModel.email.$error"
                :rules="[
                  (val) => validateEmail(val) || 'Correo electrónico no válido',
                ]"
                label="*Correo Electrónico"
                class="col-12"
              >
                <template v-slot:error>Email no válido.</template>
              </q-input>
            </q-field>
          </div>
          <div class="flex-item_10"></div>

          <div class="flex-item_40">
            <q-field borderless ref="contraseña">
              <q-input
                minlength="6"
                maxlength="12"
                hint="6 a 12 caracteres. Requiere al menos 1 número, 1 letra minúscula y 1 mayúscula"
                dense
                input-debounce="0"
                :error="$v.UsuarioExternoModel.contraseña.$error"
                :rules="[
                  (val) =>
                    !!val ||
                    'Dato Obligatorio. 6 a 12 caracteres, se requiere al menos 1 número, 1 letra minúscula y 1 mayúscula',
                  (val) =>
                    validatePassword(val) ||
                    'Contraseña no válida. 6 a 12 caracteres, se requiere al menos 1 número, 1 letra minúscula y 1 mayúscula',
                ]"
                class="col-12"
                ref="contraseña"
                v-model="UsuarioExternoModel.contraseña"
                :type="isPwd ? 'password' : 'text'"
                label="*Contraseña"
                bottom-slots
              >
                <template
v-slot:error
                  >Dato Obligatorio. 6 a 12 caracteres, se requiere al menos 1
                  número, 1 letra minúscula y 1 mayúscula.</template
                >
                <template v-slot:append>
                  <q-icon
                    :name="isPwd ? 'visibility_off' : 'visibility'"
                    class="cursor-pointer"
                    @click="isPwd = !isPwd"
                  />
                </template>
              </q-input>
            </q-field>
          </div>

          <div class="flex-item_40">
            <q-field borderless ref="repetir_contraseña">
              <q-input
                minlength="6"
                required
                maxlength="12"
                hint="6 a 12 caracteres. Requiere al menos 1 número, 1 letra minúscula y 1 mayúscula"
                dense
                input-debounce="0"
                :error="$v.UsuarioExternoModel.repetir_contraseña.$error"
                :rules="[
                  (val) =>
                    !!val ||
                    'Dato Obligatorio. 6 a 12 caracteres, se requiere al menos 1 número, 1 letra minúscula y 1 mayúscula',
                  (val) =>
                    val === this.UsuarioExternoModel.contraseña ||
                    'Las contraseñas deben coincidir',
                  (val) =>
                    validatePassword(val) ||
                    'Contraseña no válida. 6 a 12 caracteres, se requiere al menos 1 número, 1 letra minúscula y 1 mayúscula',
                ]"
                class="col-12"
                ref="repetir_contraseña"
                v-model="UsuarioExternoModel.repetir_contraseña"
                :type="isPwd ? 'password' : 'text'"
                label="*Confirmar Contraseña"
                bottom-slots
              >
                <template
v-slot:error
                  >Dato Obligatorio. 6 a 12 caracteres, se requiere al menos 1
                  número, 1 letra minúscula y 1 mayúscula.</template
                >
                <template v-slot:append>
                  <q-icon
                    :name="isPwd ? 'visibility_off' : 'visibility'"
                    class="cursor-pointer"
                    @click="isPwd = !isPwd"
                  />
                </template>
              </q-input>
            </q-field>
          </div>
          <div class="flex-item_100"></div>
          <div class="flex-item_100">
            <div>
              <q-field
                borderless
                ref="policita_privacidad"
                :error="$v.UsuarioExternoModel.AceptaGdpr.$error"
              >
                <q-checkbox
                  ref="policita_privacidad"
                  required
                  label="He leído y acepto la Política de Privacidad"
                  v-model="UsuarioExternoModel.AceptaGdpr"
                  :error="$v.UsuarioExternoModel.AceptaGdpr.$error"
                />
              </q-field>
              <div class="politica_privacidad justificar">
                <span>
                  El responsable del tratamiento es Aquatec, Proyectos para el
                  Sector del agua, S.A.U. (en adelante Aquatec). Sus datos serán
                  tratados con el fin de gestionar su inscripción a servicio
                  específico detallado en el formulario, y gestionarle noticias
                  o eventos, así como ofertas de servicios propios y en el caso
                  que haber dado su consentimiento, se le podrá remitir
                  información comercial (por medios electrónicos, impresos y/o
                  telefónicos). Puede acceder a sus datos, solicitar que se
                  modifiquen o supriman, pedir que limitemos el tratamiento,
                  ejercer el derecho a la portabilidad u oponerse al tratamiento
                  en determinados supuestos.
                </span>
              </div>
            </div>
          </div>
          <div class="flex-item_100">
            <div>
              <q-field
                borderless
                ref="comunicaciones_comerciales"
                :error="$v.UsuarioExternoModel.AvisoComercial.$error"
              >
                <q-checkbox
                  ref="comunicaciones_comerciales"
                  required
                  v-model="UsuarioExternoModel.AvisoComercial"
                >
                  <template v-slot:default>
                    <div class="comunicaciones_comerciales justificar">
                      Acepto que un equipo de Aquatec, Proyectos para el sector
                      del agua, S.A.U. se ponga en contacto conmigo para evaluar
                      el o los presupuestos generados con esta herramienta de
                      simulación (necesario para completar registro)
                    </div>
                  </template>
                </q-checkbox>
              </q-field>
            </div>
          </div>
        </q-card-actions>
        <q-card-actions align="right">
          <q-btn
            title="atrás"
            @click="atras"
            class="ma-2 buttonclaro"
            >atrás</q-btn
          >
          <q-btn
            title="enviar datos usuario"
            @click="validar_usuario"
            class="ma-2 buttonoscuro"
            >enviar</q-btn
          >
        </q-card-actions>
      </q-card>
    </div>
    <cargando :contenido_mensaje="mensaje_cargando" />
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import {
  QInput,
  QCard,
  QField,
  QCardSection,
  QCardActions,
  QCheckbox
} from 'quasar';
import Cargando from '@/components/shared/components/Cargando';

export default {
  mounted () {
    this.mensaje = '';

    this.isLoading = false;
    this.$store.commit('TSZ/setOffline', false);
  },

  methods: {
    atras () {
      this.$router.push({ name: 'registro' });
    },

    validar_usuario () {
      this.$v.UsuarioExternoModel.$touch();
      if (this.$v.UsuarioExternoModel.$error) {
        this.mostrar_mensajes(
          'Deben introducirse correctamente todos los datos',
          'red'
        );
      } else if (this.comprobar_datos_usuario_externo()) {
        this.Datos_user.mail = this.UsuarioExternoModel.email;
        this.Datos_user.isExternal = true;
        this.Datos_user.appName = 'TSZ';
        this.Datos_user.password = this.UsuarioExternoModel.contraseña;

        this.Datos_profile.nombre = this.UsuarioExternoModel.nombre;
        this.Datos_profile.apellidos = this.UsuarioExternoModel.apellidos;
        this.Datos_profile.empresa = this.UsuarioExternoModel.empresa;
        this.Datos_profile.telefono = this.UsuarioExternoModel.telefono;

        // Set GDPR
        let AceptaGdpr = this.UsuarioExternoModel.AceptaGdpr;
        let AvisoComercial = this.UsuarioExternoModel.AvisoComercial;

        let GDPR = {
          AceptaGdpr: AceptaGdpr,
          AvisoComercial: AvisoComercial
        };

        this.$store.commit('TSZ/setDatosUsuario', this.Datos_user);
        this.$store.commit('TSZ/setDatosProfile', this.Datos_profile);
        this.$store.commit('TSZ/setDatosGDPR', GDPR);
        this.$store
          .dispatch('TSZ/postDatosValidarUsuario')
          .then((response) => {
            this.ok = true;
            this.$router.push({ name: 'login' });
            this.mostrar_mensajes(
              'Para continuar el proceso debe validar el enlace enviado a su correo electrónico',
              'blue'
            );
          })

          .catch((err) => {
            this.ok = false;
            this.mostrar_mensajes(err.response.data, 'red');
          });
      } else {
        this.mostrar_mensajes(
          'Deben introducirse correctamente todos los datos',
          'red'
        );
      }
    },

    myTrim (x) {
      return x.replace(/^\s+|\s+$/gm, '');
    },

    comprobar_datos_usuario_externo () {
      if (
        this.myTrim(this.UsuarioExternoModel.nombre) === '' ||
        this.myTrim(this.UsuarioExternoModel.empresa) === '' ||
        this.myTrim(this.UsuarioExternoModel.email) === '' ||
        this.myTrim(this.UsuarioExternoModel.contraseña) === '' ||
        this.myTrim(this.UsuarioExternoModel.telefono) === '' ||
        this.myTrim(this.UsuarioExternoModel.repetir_contraseña) === '' ||
        !this.validateTfno(this.myTrim(this.UsuarioExternoModel.telefono)) ||
        !this.validatePassword(
          this.myTrim(this.UsuarioExternoModel.contraseña)
        ) ||
        !this.validatePassword(
          this.myTrim(this.UsuarioExternoModel.repetir_contraseña)
        ) ||
        this.myTrim(this.UsuarioExternoModel.repetir_contraseña) !==
          this.myTrim(this.UsuarioExternoModel.contraseña) ||
        !this.validateEmail(this.myTrim(this.UsuarioExternoModel.email))
      ) {
        return false;
      } else return true;
    },

    validateEmail (email_) {
      var re =
        // eslint-disable-next-line no-control-regex
        /^(?:[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
      return re.test(email_);
    },

    validateTfno (tfno_) {
      var re1 = /^\d{9}$/;
      var re2 = /^\d{3}-\d{3}-\d{3}$/;
      var re3 = /^\d{3}\s\d{6}$/;
      var re4 = /^\d{3}\s\d{2}\s\d{2}\s\d{2}$/;
      return (
        re1.test(tfno_) || re2.test(tfno_) || re3.test(tfno_) || re4.test(tfno_)
      );
    },

    validatePassword (password_) {
      var re1 = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,12}$/;

      return re1.test(password_);
    },

    mostrar_mensajes (mensaje, color = 'red', timeout = 5000) {
      this.$q.notify({
        message: mensaje,
        color: color,
        icon: 'warning',
        timeout: timeout,
        position: 'top-right',
        progress: true,
        actions: [{ icon: 'close', color: 'white' }]
      });
    }
  },

  validations: {
    UsuarioExternoModel: {
      nombre: { required },
      apellidos: { required },
      empresa: { required },
      telefono: { required },
      email: { required },
      contraseña: { required },
      repetir_contraseña: { required },
      AvisoComercial: { checked: (value) => value === true, required },
      AceptaGdpr: { checked: (value) => value === true, required }
    }
  },

  data () {
    return {
      mensaje: '',
      mensaje_cargando: 'registrando',
      ok: false,
      isPwd: true,
      Datos_user: {
        mail: '',
        isExternal: null,
        appName: null,
        password: null,
        id: 0
      },
      Datos_profile: {
        nombre: null,
        apellidos: null,
        empresa: null,
        telefono: null,
        id: 0
      },
      UsuarioExternoModel: {
        AvisoComercial: false,
        AceptaGdpr: false
      }
    };
  },

  components: {
    Cargando,
    QInput,
    QCard,
    QField,
    QCardSection,
    QCardActions,
    QCheckbox
  }
};
</script>
<style lang="scss" scoped>
$azulHover: #225eac;
$azuloscuro: #002f6c;
$azuloclaro: #878b97;

.buttonoscuro {
  background-color: $azuloscuro !important;
  border: none;
  color: #fff;
  font-weight: 600;
  letter-spacing: 3px;
  &:hover {
    background-color: $azulHover !important;
    color: #fff;
    font-weight: 600;
  }
}

.buttonclaro {
  border: 1px solid #002f6c;
  color: #002f6c;
  font-weight: 600;
  letter-spacing: 3px;
  &:hover {
    background-color: $azuloscuro !important;
    color: #fff;
    font-weight: 600;
  }
}

.my-card-reg-externo {
  padding: 12px;
}

.politica_privacidad {
  padding-left: 44px;
  padding-right: 8px;
}

.politica_privacidad > span {
  font-size: 11px;
  color: rgba(0, 0, 0, 0.54);
}

.justificar {
  text-align: justify;
  text-justify: inter-word;
}

.comunicaciones_comerciales {
  padding-right: 8px;
  text-align: justify;
  text-justify: inter-word;
}
</style>
